import { PADDING_CIRCLE_PARENT, PADDING_CIRCLE_PARENT_ONLY_ONE_CHILD, PADDING_PERCENTAGE_COLLISION, RANGE_RADIUS } from '../constants';
import { beforeTraversal } from '../recursions/before-traversal';
import { color } from './color';
import { scaleValueToRadius } from './helpers/scales';
import { text } from './text';

import * as d3 from 'd3';

/**
 * this method mutates the data adding extra properties like r,x,y, depth and ancestors...
 *
 * @param data Hierarchical data
 * @param colors map of category colors
 * @param formatLabel method to give format to the label
 */
export const packing: (data: any, colors: { [key: string]: string } | string, formatLabel: (label: string) => string) => void = (
  data,
  colors,
  formatLabel
) => {
  beforeTraversal(data, (node, ancestors, index) => {
    //  Node Depth
    node.depth = index;

    // Node Children
    // eslint-disable-next-line no-self-assign
    node.children = node.children;

    // Ancestors
    node.ancestors = ancestors;

    //  Text size and wrapped
    text(node, formatLabel);

    //  Color
    color(node, colors);

    if (!node.children || !node.children.length) {
      return;
    }

    //  We set radius for children
    node.children.forEach((d) => {
      d.rOrig = scaleValueToRadius(node.children, RANGE_RADIUS, d.doc_count);
      d.r = scaleValueToRadius(node.children, RANGE_RADIUS, d.doc_count) * PADDING_PERCENTAGE_COLLISION;
    });

    //  Run sibling packing that writes the x, y, and r props
    d3.packSiblings(node.children);

    node.children.forEach((d) => {
      d.r = d.rOrig;
    });

    if (index === 0) {
      return;
    }
    /**
     * SCALE CALCULATION
     */

    //  To make fit the children circles inside the circle parent
    //  we need calculate the enclosing circle and then
    //  we apply a scale the make it fit in the parent size

    const enclosingCircle = d3.packEnclose(node.children);

    const enclosingCircleR = enclosingCircle.r * (node.children.length > 1 ? PADDING_CIRCLE_PARENT : PADDING_CIRCLE_PARENT_ONLY_ONE_CHILD);
    const scale = node.r / enclosingCircleR;

    //  Re scale children to make them fit in size of their parent
    node.children.forEach((child) => {
      child.r *= scale;
      child.x = child.x * scale + node.x;
      child.y = child.y * scale + node.y;
    });
  });
};
